import { ShowSVG } from '../../../../components/showSVG/ShowSVG'
import { displayMessage } from '../../../../helpers/messages'

export const IconZone = ({ deviceInfo, iconSize, absoluteX, absoluteY }) => {

    const iconStyle = {
        position: 'absolute',
        top: `${absoluteY}px`, 
        left: `${absoluteX}px`,
        transform: 'translate(-50%, -50%)', 
        cursor: 'pointer',
    };

    const zIndexes = {
        0: 'z-30 ',
        1: 'z-20 ',
        2: 'z-10 ',
    }

    return (
        <div>
            <span
                title={deviceInfo.label}
                className={`iconZone ${zIndexes[deviceInfo.priority] ?? 'z-0'} ${iconSize} absolute float-left central-modal-devices flex justify-center items-center`}
                style={{
                    ...iconStyle,
                    position: 'absolute',
                    backgroundColor: deviceInfo.color,
                }}
            >
                <ShowSVG icon={deviceInfo.icon} className="central-modal-devices-icon" />
            </span>
        </div>
    )
}